<template>
  <div
    class="tab-item active"
    data-tab="complaints"
  >
    <section class="block">
      <div class="block__headline">
        <div class="block__title headline-1">
          <i class="icon-grp-7 block__icon"></i>
          Complaints
        </div>


        <button
          class="btn btn--border btn-text modal-open"
          data-target="complaint"
        >
          <span class="btn__value">Submit complaint</span>
        </button>
      </div>

      <div class="post-list">
        <div class="tag-wrapper">
          <div class="select-wrapper">
            <div class="select body-1">
              <span class="select__label">Sorted by</span>
              <span class="select__value">recently added</span>
              <div class="select__menu">
                <span class="select__option active">recently added</span>
                <span class="select__option">oldest</span>
                <span class="select__option">max</span>
                <span class="select__option">min</span>
              </div>
            </div>
          </div>


          <div class="radio-row">
            <div class="radio-list">
              <span class="btn radio btn-text"><span class="btn__value">All (76)</span></span>
              <span class="btn radio btn-text"><span class="btn__value">Open (50)</span></span>
              <span class="btn radio btn-text"><span class="btn__value">Resolved
                  (11)</span></span>
              <span class="btn radio btn-text"><span class="btn__value">Unresolved
                  (9)</span></span>
              <span class="btn radio btn-text"><span class="btn__value">Rejected (6)</span></span>
            </div>
          </div>

        </div>

        <div class="post-wrapper">
          <div class="post post--after">
            <div class="post__title">
              <h3 class="headline-2">Title</h3>
              <div class="post__title-row">
                <span class="post__badge body-2 bg-orange-2">
                  <span class="post__badge-icon icon-open"></span>
                  Open
                </span>
                <span class="post__badge body-2 bg-green">
                  <span class="post__badge-icon icon-resolved"></span>
                  Resolved
                </span>
                <span class="post__badge body-2 bg-blue-2">
                  <span class="post__badge-icon icon-unresolved"></span>
                  Unresolved
                </span>
                <span class="post__badge body-2 bg-red">
                  <span class="post__badge-icon icon-rejected"></span>
                  Rejected
                </span>
                <span class="op-045 body-1">18h 15m left</span>
              </div>
            </div>
            <div class="post__row">
              <div class="post__line">
                <div class="post__headline">
                  <div class="post__author">
                    <div class="post__author-img">
                      <img
                        src="./assets/images/png/Ellipse.png"
                        alt=""
                        class="img img--cover"
                      >
                    </div>
                    <div class="post__author-about">
                      <p class="headline-4">{username}</p>
                      <div class="post__author-data">
                        <span class="post__author-value body-2">5 complaints</span>
                        <span class="post__author-value body-2">24 Jul 2022</span>
                      </div>
                    </div>

                  </div>
                  <i class="post__icon pointer c-cyan icon-menu"></i>
                </div>
                <h3 class="headline-2">“<a href="">Public Sale Mint</a>”</h3>
              </div>
            </div>

            <div class="post__row">
              <p class="body-1 post__text">Lorem ipsum dolor sit amet consectetur. Justo feugiat
                habitant viverra arcu et. Mi ut sed aliquam dignissim bibendum non natoque
                pellentesque. Risus in purus id lectus vel lectus. Viverra pharetra gravida
                adipiscing fermentum fermentum facilisi non eleifend turpis. Tortor elit nunc
                turpis ornare orci consectetur sed enim at. Ut aliquet diam at mollis sociis
                pretium tortor aliquam. Eu pulvinar massa pellentesque sit eros nisl.
                <span class="link text-bold">Read more</span>

              </p>
            </div>

            <div class="post-slider">
              <div class="post-slider__headline">
                <div class="post-slider__nav">
                  <i class="post-slider__nav-prev post__icon icon-arrow-left"></i>
                  <i class="post-slider__nav-next post__icon icon-arrow-right"></i>
                </div>

              </div>
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-3.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-3.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-3.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>

              </div>
            </div>

            <div class="post__web-wrapper body-2">
              <span class="op-045">Additional links:</span>
              <div class="post__web">
                <i class="post__icon icon-external-link c-pink"></i>
                Visit website

                <span class="post__web-data body-2">
                  Website: www.webname.com
                </span>
              </div>
              <span class="link post__web-btn">...view more</span>
            </div>

            <div class="post__row f-end">
              <i
                class="post__icon pointer c-cyan icon-share modal-open"
                data-target="share"
              ></i>
              <div class="post__replay post-replay">
                <i class="post__icon icon-arrow-top-left"></i> Replay
              </div>
            </div>
            <div class="post__replay-field">
              <div class="post post--replies">

                <div class="post__row post__row--input">
                  <textarea
                    aria-label=""
                    class="post__field body-1"
                  ></textarea>
                </div>

                <div class="post__row f-end">
                  <button class="post__replay post-cancel">
                    Cancel
                  </button>
                  <button class="post__replay post-submit">
                    Submit
                  </button>
                </div>


              </div>
            </div>
          </div>

          <div class="post-show">
            <i class="post__icon post-show__icon icon-unfold-more"></i>
            2 more replies
          </div>
        </div>

        <div class="post-wrapper">
          <div class="post">
            <div class="post__title">
              <h3 class="headline-2">Title</h3>
              <div class="post__title-row">
                <span class="post__badge body-2 bg-orange-2">
                  <span class="post__badge-icon icon-open"></span>
                  Open
                </span>
                <span class="post__badge body-2 bg-green">
                  <span class="post__badge-icon icon-resolved"></span>
                  Resolved
                </span>
                <span class="post__badge body-2 bg-blue-2">
                  <span class="post__badge-icon icon-unresolved"></span>
                  Unresolved
                </span>
                <span class="post__badge body-2 bg-red">
                  <span class="post__badge-icon icon-rejected"></span>
                  Rejected
                </span>
                <span class="op-045 body-1">18h 15m left</span>
              </div>
            </div>
            <div class="post__row">
              <div class="post__line">
                <div class="post__headline">
                  <div class="post__author">
                    <div class="post__author-img">
                      <img
                        src="./assets/images/png/Ellipse.png"
                        alt=""
                        class="img img--cover"
                      >
                    </div>
                    <div class="post__author-about">
                      <p class="headline-4">{username}</p>
                      <div class="post__author-data">
                        <span class="post__author-value body-2">5 complaints</span>
                        <span class="post__author-value body-2">24 Jul 2022</span>
                      </div>
                    </div>

                  </div>
                  <i class="post__icon pointer c-cyan icon-menu"></i>
                </div>
                <h3 class="headline-2">“<a href="">Public Sale Mint</a>”</h3>
              </div>
            </div>

            <div class="post__row">
              <p class="body-1 post__text">Lorem ipsum dolor sit amet consectetur. Justo feugiat
                habitant viverra arcu et. Mi ut sed aliquam dignissim bibendum non natoque
                pellentesque. Risus in purus id lectus vel lectus. Viverra pharetra gravida
                adipiscing fermentum fermentum facilisi non eleifend turpis. Tortor elit nunc
                turpis ornare orci consectetur sed enim at. Ut aliquet diam at mollis sociis
                pretium tortor aliquam. Eu pulvinar massa pellentesque sit eros nisl.
                <span class="link text-bold">Read more</span>

              </p>
            </div>

            <div class="post-slider">
              <div class="post-slider__headline">
                <div class="post-slider__nav">
                  <i class="post-slider__nav-prev post__icon icon-arrow-left"></i>
                  <i class="post-slider__nav-next post__icon icon-arrow-right"></i>
                </div>

              </div>
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-2.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-3.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-3.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="post-item">
                    <img
                      src="./assets/images/jpg/cat-3.jpg"
                      alt=""
                      class="img img--cover"
                    >
                  </div>
                </div>

              </div>
            </div>

            <div class="post__web-wrapper body-2">
              <span class="op-045">Additional links:</span>
              <div class="post__web">
                <i class="post__icon icon-external-link c-pink"></i>
                Visit website

                <span class="post__web-data body-2">
                  Website: www.webname.com
                </span>
              </div>
              <span class="link post__web-btn">...view more</span>
            </div>

            <div class="post__row f-end">
              <i
                class="post__icon pointer c-cyan icon-share modal-open"
                data-target="share"
              ></i>
              <div class="post__replay post-replay">
                <i class="post__icon icon-arrow-top-left"></i> Replay
              </div>
            </div>

            <div class="post__replay-field">
              <div class="post post--replies">

                <div class="post__row post__row--input">
                  <textarea
                    aria-label=""
                    class="post__field body-1"
                  ></textarea>
                </div>

                <div class="post__row f-end">
                  <button class="post__replay post-cancel">
                    Cancel
                  </button>
                  <button class="post__replay post-submit">
                    Submit
                  </button>
                </div>


              </div>
            </div>

            <div class="post__replies">
              <div class="post post--replies">
                <div class="post__row">
                  <div class="post__line">
                    <div class="post__headline">
                      <div class="post__author">
                        <div class="post__author-img">
                          <img
                            src="./assets/images/png/Ellipse-4.png"
                            alt=""
                            class="img img--cover"
                          >
                        </div>
                        <div class="post__author-about">
                          <p class="headline-4">{username}</p>
                          <div class="post__author-data">
                            <span class="post__author-value body-2">5 complaints</span>
                            <span class="post__author-value body-2">24 Jul 2022</span>
                          </div>
                        </div>

                      </div>
                      <i class="post__icon pointer c-cyan icon-menu"></i>
                    </div>
                  </div>
                </div>

                <div class="post__row">
                  <p class="body-1 post__text">Lorem ipsum dolor sit amet consectetur. Justo
                    feugiat
                    habitant viverra arcu et. Mi ut sed aliquam dignissim bibendum non natoque
                    pellentesque. Risus in purus id lectus vel lectus. Viverra pharetra gravida
                    adipiscing fermentum fermentum facilisi non eleifend turpis. Tortor elit nunc
                    turpis ornare orci consectetur sed enim at. Ut aliquet diam at mollis sociis
                    pretium tortor aliquam. Eu pulvinar massa pellentesque sit eros nisl.
                    <span class="link text-bold">Read more</span>
                  </p>
                </div>

                <div class="post__row f-end">
                  <i
                    class="post__icon pointer c-cyan icon-share modal-open"
                    data-target="share"
                  ></i>
                  <div class="post__replay post-replay">
                    <i class="post__icon icon-arrow-top-left"></i> Replay
                  </div>
                </div>
                <div class="post__replay-field">
                  <div class="post post--replies">

                    <div class="post__row post__row--input">
                      <textarea
                        aria-label=""
                        class="post__field body-1"
                      ></textarea>
                    </div>

                    <div class="post__row f-end">
                      <button class="post__replay post-cancel">
                        Cancel
                      </button>
                      <button class="post__replay post-submit">
                        Submit
                      </button>
                    </div>


                  </div>
                </div>
              </div>

              <div class="post post--replies">
                <div class="post__row">
                  <div class="post__line">
                    <div class="post__headline">
                      <div class="post__author">
                        <div class="post__author-img">
                          <img
                            src="./assets/images/png/Ellipse-3.png"
                            alt=""
                            class="img img--cover"
                          >
                        </div>
                        <div class="post__author-about">
                          <p class="headline-4">{username}</p>
                          <div class="post__author-data">
                            <span class="post__author-value body-2">5 complaints</span>
                            <span class="post__author-value body-2">24 Jul 2022</span>
                          </div>
                        </div>

                      </div>
                      <i class="post__icon pointer c-cyan icon-menu"></i>
                    </div>
                  </div>
                </div>
                <div class="post__quote">
                  <div class="post__headline">
                    <div class="post__author">
                      <div class="post__author-about">
                        <p class="headline-4">{username}</p>
                        <div class="post__author-data">
                          <span class="post__author-value body-2">5 complaints</span>
                          <span class="post__author-value body-2">24 Jul 2022</span>
                        </div>
                      </div>

                    </div>
                  </div>
                  <p class="body-1">“Mi ut sed aliquam dignissim bibendum non natoque
                    pellentesque. Risus in purus id lectus vel lectus.”</p>
                </div>
                <p class="body-1 post__text">Lorem ipsum dolor sit amet consectetur. Justo feugiat
                  habitant viverra arcu et.</p>


                <div class="post__row f-end">
                  <i
                    class="post__icon pointer c-cyan icon-share modal-open"
                    data-target="share"
                  ></i>
                  <div class="post__replay post-replay">
                    <i class="post__icon icon-arrow-top-left"></i> Replay
                  </div>
                </div>
                <div class="post__replay-field">
                  <div class="post post--replies">

                    <div class="post__row post__row--input">
                      <textarea
                        aria-label=""
                        class="post__field body-1"
                      ></textarea>
                    </div>

                    <div class="post__row f-end">
                      <button class="post__replay post-cancel">
                        Cancel
                      </button>
                      <button class="post__replay post-submit">
                        Submit
                      </button>
                    </div>


                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>


      </div>


    </section>
  </div>
</template>